import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const OPERATORS = ['=', 'LIKE', '<>', 'IN'];

export const DetailsTableForm = ({ values = {}, onFieldsChange, t }) => {
    const [config, setConfig] = useState({
        path: values?.path || '/tableViews/:params',
        id_user_action: values?.id_user_action || '',
        filters: values?.filters || {},
    });
    const [newFilterField, setNewFilterField] = useState('');

    useEffect(() => {
        onFieldsChange(config);
    }, [config, onFieldsChange]);

    const handleChange = (field, value) => {
        setConfig(prev => ({ ...prev, [field]: value }));
    };

    const handleAddFilter = () => {
        if (!newFilterField.trim()) return;
        setConfig(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                [newFilterField]: {
                    value: `{${newFilterField}}`,
                    operator: '=',
                    type: 'string',
                },
            },
        }));
        setNewFilterField('');
    };

    const handleFilterChange = (key, field, value) => {
        setConfig(prev => ({
            ...prev,
            filters: {
                ...prev.filters,
                [key]: { ...prev.filters[key], [field]: value },
            },
        }));
    };

    const handleDeleteFilter = (key) => {
        setConfig(prev => {
            const filters = { ...prev.filters };
            delete filters[key];
            return { ...prev, filters };
        });
    };

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" sx={{ mb: 2 }}>
                {t('interface.detailsTableConfig')}
            </Typography>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                        fullWidth size="small" label="Path"
                        value={config.path}
                        onChange={(e) => handleChange('path', e.target.value)}
                        helperText="Ej: /tableViews/:params"
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <TextField
                        fullWidth size="small" label="id_user_action"
                        value={config.id_user_action}
                        onChange={(e) => handleChange('id_user_action', e.target.value)}
                        helperText="ID o work_flow del SUBMENU relacionado"
                    />
                </Grid>

                <Grid size={{ xs: 10, sm: 5 }}>
                    <TextField
                        fullWidth size="small" label={t('common.filter.field')}
                        value={newFilterField}
                        onChange={(e) => setNewFilterField(e.target.value)}
                        placeholder="id_unique"
                    />
                </Grid>
                <Grid size={{ xs: 2, sm: 1 }}>
                    <IconButton color="primary" onClick={handleAddFilter}>
                        <AddIcon />
                    </IconButton>
                </Grid>

                {Object.entries(config.filters).map(([key, filter]) => (
                    <Grid size={{ xs: 12 }} key={key}>
                        <Grid container spacing={2} alignItems="center"
                            sx={{ backgroundColor: '#fafafa', borderRadius: 2, px: 2, py: 1.5 }}
                        >
                            <Grid size={{ xs: 12, sm: 2 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>{key}</Typography>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 3 }}>
                                <TextField fullWidth size="small" label={t('common.filter.value')}
                                    value={filter.value}
                                    onChange={(e) => handleFilterChange(key, 'value', e.target.value)}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 2 }}>
                                <FormControl fullWidth size="small">
                                    <InputLabel>{t('common.filter.operator')}</InputLabel>
                                    <Select label={t('common.filter.operator')} value={filter.operator}
                                        onChange={(e) => handleFilterChange(key, 'operator', e.target.value)}
                                    >
                                        {OPERATORS.map(op => <MenuItem key={op} value={op}>{op}</MenuItem>)}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 2 }}>
                                <TextField fullWidth size="small" label={t('commonFields.type')}
                                    value={filter.type}
                                    onChange={(e) => handleFilterChange(key, 'type', e.target.value)}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 1 }}>
                                <IconButton color="error" onClick={() => handleDeleteFilter(key)}>
                                    <DeleteIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
